import React, { useEffect, useState } from "react";
import { MenuOverlay } from "./MenuOverlay";

/**
 * Wires `window.dispatchEvent('rebel:toggle-menu')` to open/close
 * the Sofi-style overlay, and broadcasts state via `rebel:menu-state`
 * so the navbar burger can mirror its visual state.
 */
export const MenuOverlayController = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onToggle = () => setOpen((o) => !o);
    window.addEventListener("rebel:toggle-menu", onToggle);
    return () => window.removeEventListener("rebel:toggle-menu", onToggle);
  }, []);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("rebel:menu-state", { detail: { open } })
    );
  }, [open]);

  return <MenuOverlay open={open} onClose={() => setOpen(false)} />;
};

export default MenuOverlayController;
